import React from 'react';
import Box from '../../basic/box';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import {
  DataAnalyticsClicksFavorites,
  DataAnalyticsLocations,
  DataAnalyticsTypes,
} from '../../basic/analytics';
import { buildAnalyticsLocations } from '../../basic/quickLink';
import { sanitizeAndLowercaseString } from '../../../utils/common';
import useSplunkLogger from '../../../common/hooks/useSplunkLogger';

export default function ProductColor({
  color,
  handleVariant,
  isSelected,
  colorScheme,
}: {
  color: string;
  isSelected: boolean;
  handleVariant: any;
  colorScheme: Record<string, Record<string, string>>;
}): JSX.Element {
  const { t } = useTranslation();
  const {splunkLogger} = useSplunkLogger()

  let btnStyles = 'group rounded-full border cursor-pointer';
  btnStyles += isSelected
    ? 'ring-offset-3 ring-1 xl:ring-2 ring-black sm:p-[1px]'
    : 'border-gray-300';
  let colorMapped = '';
  if (colorScheme) colorMapped = colorScheme[sanitizeAndLowercaseString(color)]?.color;

  const handleKeyDown = (evt: any, color: string) => {
    if (evt.key === 'Enter') {
      handleVariant(evt, color);
      evt.preventDefault();
    }
  };
  const dataAnalyticsLocation = buildAnalyticsLocations([
    DataAnalyticsLocations.Page,
    DataAnalyticsLocations.Body,
    DataAnalyticsLocations.Grid,
    DataAnalyticsLocations.Card,
  ],splunkLogger);
  return (
    <>
      <button
        className={btnStyles}
        onKeyDown={evt => handleKeyDown(evt, color)}
        onClick={evt => {
          handleVariant(evt, color);
        }}
        data-analytics-type={DataAnalyticsTypes.Media}
        data-analytics-click={DataAnalyticsClicksFavorites.VIEW_EYEGLASS_FRAME_VARIANT}
        data-analytics-location={dataAnalyticsLocation}
        data-testid={'btn-product-color'}
        role="button"
        aria-live={document.activeElement === document.querySelector('[data-testid="btn-product-color"]') ? 'assertive' : undefined}
        aria-label={
          t(`${color} color variant ${isSelected ? 'Selected' : 'Not Selected'}`) as string
        }
      >
        <Box
          className={`${colorMapped} w-sm h-sm md:w-[0.9em] md:h-[0.9em] xl:w-[1.2em] xl:h-[1.2em]`}
          shape="circle"
          aria-hidden="true"
        />
      </button>
      {/* {isSelected ? (<div className="text-2xs md:text-xs mt-2xs text-gray-900 uppercase mb-[11px]">{color}</div>):(<div className='mt-2xs mb-[26px]'></div>)} */}
    </>
  );
}
